module.exports = __webpack_public_path__ + "static/img/20230710_01.0c98f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230710_01.png
// module id = 3YMw
// module chunks = 0